export default __webpack_public_path__ + "static/media/IMG_4531-min.58c3b809.JPG";